var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sub-account" },
    [
      _c("label", { staticClass: "emphasis sub-title" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("settings.user.vendor.subAccounts"))),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "sub-title-hint" }, [
          _vm._v(
            "(" +
              _vm._s(
                _vm.$t("settings.user.vendor.subAccountsHint", [
                  _vm.maxNumOfVendorSubAccount,
                ])
              ) +
              ")"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "VendorSubList",
        {
          ref: "vendorSubList",
          attrs: {
            accountId: _vm.accountInfo.vendorId,
            accountName: _vm.accountInfo.name,
            allowInvite: _vm.hasAddPerm,
            allowEdit: _vm.editSub,
            allowEditSwp: !!_vm.swpEnabled,
            activeDepartmentId: _vm.activeDepartmentId,
          },
          on: {
            "close:edit": function (hideEdit) {
              return _vm.enableSubEdit(false, hideEdit)
            },
            "allow:add": function (val) {
              return (_vm.allowAdd = val)
            },
            "hide:edit": function (val) {
              return (_vm.hideSubEdit = val)
            },
          },
        },
        [
          _vm.isContractorAdmin && _vm.hasAddPerm
            ? _c(
                "template",
                { slot: "add-sub-account" },
                [
                  _vm.allowAdd
                    ? _c(
                        "DialogSlot",
                        {
                          ref: "add-sub-account",
                          attrs: {
                            id: "settings-users-contractor-add-subaccount",
                            modalBtn: _vm.addSubAccLabel,
                            modalHeader: _vm.addSubAccLabel,
                            disableBtn: _vm.editSub,
                            showCloseBtn: false,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "content", id: "addSubAccModal" },
                              slot: "content",
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "emphasis required-flag" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("settings.user.vendor.name")
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.subAccount.name,
                                    expression: "subAccount.name",
                                  },
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                  {
                                    name: "fusioninputcheck",
                                    rawName: "v-fusioninputcheck",
                                    value: {
                                      type: "string",
                                      pattern: _vm.regex.nonEmptyString,
                                      tip: _vm.$t("hint.inputTip.string"),
                                      required: true,
                                      classes: "tooltip-class",
                                    },
                                    expression:
                                      "{\n              type: 'string',\n              pattern: regex.nonEmptyString,\n              tip: $t('hint.inputTip.string'),\n              required: true,\n              classes: 'tooltip-class'}",
                                  },
                                ],
                                attrs: { type: "text", required: "" },
                                domProps: { value: _vm.subAccount.name },
                                on: {
                                  change: function ($event) {
                                    return _vm.validateSubAccount()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.subAccount,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { staticClass: "emphasis required-flag" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("settings.user.vendor.email")
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.subAccount.username,
                                    expression: "subAccount.username",
                                    modifiers: { trim: true },
                                  },
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                  {
                                    name: "fusioninputcheck",
                                    rawName: "v-fusioninputcheck",
                                    value: {
                                      type: "string",
                                      pattern: _vm.regex.email,
                                      tip: _vm.$t("hint.inputTip.email"),
                                      required: true,
                                      classes: "tooltip-class",
                                    },
                                    expression:
                                      "{\n              type: 'string',\n              pattern: regex.email,\n              tip: $t('hint.inputTip.email'),\n              required: true,\n              classes: 'tooltip-class'}",
                                  },
                                ],
                                class: _vm.usernameErrClass,
                                attrs: { type: "text", required: "" },
                                domProps: { value: _vm.subAccount.username },
                                on: {
                                  change: function ($event) {
                                    return _vm.validateSubAccount()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.subAccount,
                                      "username",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", { staticClass: "emphasis" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("settings.user.vendor.allowPerms")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.enableTenderFeature
                                ? _c("div", { staticClass: "check-perm" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "hkldinput",
                                          rawName: "v-hkldinput",
                                        },
                                      ],
                                      attrs: {
                                        id: "settings-users-contractor-subPerms-tender",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked:
                                          _vm.subAccount.perms[
                                            _vm.Rcs.ContractorTender
                                          ],
                                      },
                                      on: {
                                        change: function (event) {
                                          return _vm.addPerms(
                                            event.target.checked,
                                            _vm.Rcs.ContractorTender
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "contractor-perm",
                                        attrs: {
                                          for: "settings-users-contractor-subPerms-tender",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.subAccTableElements[
                                                _vm.Rcs.ContractorTender
                                              ]
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.enableProjectFeature
                                ? _c("div", { staticClass: "check-perm" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "hkldinput",
                                          rawName: "v-hkldinput",
                                        },
                                      ],
                                      attrs: {
                                        id: "settings-users-contractor-subPerms-project",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked:
                                          _vm.subAccount.perms[
                                            _vm.Rcs.ContractorProject
                                          ],
                                      },
                                      on: {
                                        change: function (event) {
                                          return _vm.addPerms(
                                            event.target.checked,
                                            _vm.Rcs.ContractorProject
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "contractor-perm",
                                        attrs: {
                                          for: "settings-users-contractor-subPerms-project",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.subAccTableElements[
                                                _vm.Rcs.ContractorProject
                                              ]
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.enableWorkPermitsFeature
                                ? _c("div", { staticClass: "check-perm" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "hkldinput",
                                          rawName: "v-hkldinput",
                                        },
                                      ],
                                      attrs: {
                                        id: "settings-users-contractor-subPerms-swp",
                                        type: "checkbox",
                                        disabled: !_vm.swpEnabled,
                                      },
                                      domProps: {
                                        checked:
                                          _vm.subAccount.perms[
                                            _vm.Rcs.StandaloneWorkPermits
                                          ],
                                      },
                                      on: {
                                        change: function (event) {
                                          return _vm.addPerms(
                                            event.target.checked,
                                            _vm.Rcs.StandaloneWorkPermits
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "contractor-perm",
                                        attrs: {
                                          for: "settings-users-contractor-subPerms-swp",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.subAccTableElements[
                                                _vm.Rcs.StandaloneWorkPermits
                                              ]
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.enableEcircularFeature
                                ? _c("div", { staticClass: "check-perm" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "hkldinput",
                                          rawName: "v-hkldinput",
                                        },
                                      ],
                                      attrs: {
                                        id: "settings-users-admin-vendor-contacts",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked:
                                          _vm.subAccount.perms[
                                            _vm.Rcs.ContractorSettings
                                          ],
                                      },
                                      on: {
                                        change: function (event) {
                                          return _vm.addPerms(
                                            event.target.checked,
                                            _vm.Rcs.ContractorSettings
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "contractor-perm",
                                        attrs: {
                                          for: "settings-users-admin-vendor-contacts",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.subAccTableElements[
                                                _vm.Rcs.ContractorSettings
                                              ]
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.enableTenderFeature &&
                              !_vm.enableProjectFeature &&
                              !_vm.enableWorkPermitsFeature &&
                              !_vm.enableEcircularFeature
                                ? _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("emptyValue")) +
                                        "\n          "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { slot: "buttons" }, slot: "buttons" },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "hkldreset",
                                      rawName: "v-hkldreset",
                                    },
                                  ],
                                  staticClass: "btn btn--orange",
                                  attrs: {
                                    type: "button",
                                    role: "cancel-button",
                                  },
                                  on: {
                                    click: function () {
                                      return _vm.closeModal()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "hkldreset",
                                      rawName: "v-hkldreset",
                                    },
                                  ],
                                  staticClass: "btn btn--darkblue",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.disableAddSub,
                                    role: "new-button",
                                  },
                                  on: {
                                    click: function () {
                                      return _vm.addSubAccount()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("action.add")))]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.hideSubEdit,
                          expression: "!hideSubEdit",
                        },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button", role: "edit-button" },
                      on: {
                        click: function () {
                          return _vm.enableSubEdit(true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.edit")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }